module.exports = __webpack_public_path__ + "static/img/designGuide12.6adc92d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide12.png
// module id = clt2
// module chunks = 2